module.exports = __webpack_public_path__ + "img/16.f558ed3b.jpg";